import {ChecklistTemplateType} from '@domain/hroc-checklists'
import {Tag} from '@hconnect/common/components'

import {useWidgetTranslation} from '../hooks'

type Props = {
  type: ChecklistTemplateType
  description: string
}

export const ChecklistTemplateDetails = ({type, description}: Props) => {
  const {t} = useWidgetTranslation()

  return (
    <>
      <Tag label={t('label.type')} data-test-id="template-type">
        {t(`checklist.templateType.${type}`)}
      </Tag>
      <Tag label={t('label.description')} data-test-id="template-description">
        {description}
      </Tag>
    </>
  )
}
